<template>
	<!-- 折线 柱状 条形 -->
	<!-- 条形 -->
	<div class="manyChart">
		<div class="title_box">
			<span class="title_box_span">
				<span class="textlong" :title="CrossTabs.name">
					<span >{{ CrossTabs.sheet }}:</span>
						{{ htmlToString(CrossTabs.name) }}
				</span>
			</span>
			<span class="el-dropdown_button">
				<el-button plain style="margin-top: 10px; margin-right: 10px" @click="exportExcl(CrossTabs.id)">{{$t('DataRecycling.Export')}}</el-button>
				
				<el-select :popper-append-to-body="false" v-model="CrossTabs.chartType" :key="CrossTabs.id" :placeholder="$t('DataRecycling.PleaseSelect')" @change="selection">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</span>
		</div>
		<div class="echart" ref="echart_div"></div>
		<div class="">
			<table border="1">
				<tr v-for="(item, index) in CrossTabs.dataArrayList" :key="index" class="table_tr">
					<td v-for="(item1, index1) in item" :key="index1">{{ item1 }}</td>
				</tr>
				<tr>
					<td colspan="100">{{$t('DataRecycling.NumberOfRespondents')}} : {{ CrossTabs.answerNumber }}</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<script>
import echarts from 'echarts';
export default {
	props: {
		CrossTabs: {
			type: Object //可指定接收类型，如:Array.
		},
		CrossTabsindex: {}
	},
	data() {
		return {
			wid:0,
			barData: [], //条行图 数据
			barName: [], //条形图 名字
			options: [
				{
					value: '5',
					label: this.$t('DataRecycling.FoldLine')
				},
				{
					value: '2',
					label: this.$t('DataRecycling.Histogram')
				},
				{
					value: '3',
					label: this.$t('DataRecycling.BarChart')
				}
			]
		};
	},
	mounted() {
		this.wid = sessionStorage.getItem('wid') || this.$route.query.wid || 0;
		this.loadData();
	},
	methods: {
		exportExcl(qid) {
			console.log('CrossTabs', this.CrossTabs);
			var id = this.wid;
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.exportChoice}?id=${id}&state=0&Authorization=Bearer${window.localStorage.getItem('token')}&qid=${qid}&isbank=${that.CrossTabs.isbank}`,
				method: 'Get',
			 data: {},
				cb(res) {
					if (res.code == 0) {
						that.popUpPrompt()
					} else {
						that.$message.warning(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		popUpPrompt() {
			this.$notify({
				dangerouslyUseHTMLString: true,
				message: `${this.$t('DataRecycling.DataPreparationInProgress')} 
							<a href="#" class="notify-link" id="my-download-link">
								<span style="color: blue;">${this.$t('DataRecycling.MyDownload')}</span>
							</a> 
							${this.$t('DataRecycling.CanViewProgress')}`
			});
			this.$nextTick(() => {
				const link = document.querySelector('#my-download-link');
				if (link) {
					link.addEventListener('click', (e) => {
						e.preventDefault(); // 阻止默认的链接跳转
						this.$router.push('/MyProject'); // 使用 Vue Router 跳转
					});
				}
			});
		},
		htmlToString(htmlStr){
			return htmlStr.replace(/<\/?.+?\/?>|\r|\n*/g,'')
		},
		selection(val) {
			this.barData = [];
			this.barName = [];
			if (val == 2) {
				this.histogram();
			}
			if (val == 3) {
				this.longBar();
			}
			if (val ==5){
				this.broken()
			}
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setStatisticalStyle}`,
				method: 'POST',
				data: {
					id: that.CrossTabs.id,
					chartType: val,
					isBank: that.CrossTabs.isbank
				},
				cb(res) {
					if (res.code == 0) {
					}
				}
			};
			this.$util.request(params);
		},
		// 折线图
		broken(){
			let temporary = this.CrossTabs.dataArrayList;
			for (let i = 1; i < temporary.length; i++) {
				this.barData.push(temporary[i][1]);
				let temporaryName = ''
				temporaryName= this.htmlToString(temporary[i][0])
				if (!temporaryName) return '';
				if (temporaryName.length > 10) {
					temporaryName = temporaryName.slice(0, 10) + '...';
				}
				this.barName.push(temporaryName);
			}
			
			let getchart = echarts.init(this.$refs.echart_div);
			let option = {
				color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f', '#dadde2'],
				xAxis: {
				        type: 'category',
				        data:this.barName
				    },
				    yAxis: {
				        type: 'value'
				    },
				    series: [{
				        data: this.barData,
				        type: 'line'
				    }]
			};
			getchart.clear();
			getchart.setOption(option);
			//随着屏幕大小调节图表
			window.addEventListener('resize', () => {
				getchart.resize();
			});
		},
		// 柱状图
		histogram() {
			// console.log(this.CrossTabs.dataArrayList)
			let temporary = this.CrossTabs.dataArrayList;
			for (let i = 1; i < temporary.length; i++) {
				this.barData.push(temporary[i][1]);
				let temporaryName = ''
				temporaryName= this.htmlToString(temporary[i][0])
				if (!temporaryName) return '';
				if (temporaryName.length > 10) {
					temporaryName = temporaryName.slice(0, 10) + '...';
				}
				this.barName.push(temporaryName);
			}
			let getchart = echarts.init(this.$refs.echart_div);
			let option = {
				color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f', '#dadde2'],
				xAxis: {
					type: 'category',
					data: this.barName
				},
				yAxis: {
					type: 'value'
				},
				series: [
					{
						data: this.barData,
						type: 'bar'
					}
				]
			};
			getchart.clear();
			getchart.setOption(option);
			//随着屏幕大小调节图表
			window.addEventListener('resize', () => {
				getchart.resize();
			});
		},
		// 条形图
		longBar() {
			let temporary = this.CrossTabs.dataArrayList;
			for (let i = 1; i < temporary.length; i++) {
				this.barData.push(temporary[i][1]);
				let temporaryName = ''
				temporaryName= this.htmlToString(temporary[i][0])
				if (!temporaryName) return '';
				if (temporaryName.length > 10) {
					temporaryName = temporaryName.slice(0, 10) + '...';
				}
				this.barName.push(temporaryName);
			}
			let getchart = echarts.init(this.$refs.echart_div);
			let option = {
				color: ['#0080ff', '#55acff', '#8ce0ff', '#898c9c', '#1f6588', '#18aeb7', '#f86d3f', '#dadde2'],
				yAxis: {
					type: 'category',
					data: this.barName
				},
				xAxis: {
					type: 'value'
				},
				series: [
					{
						data: this.barData,
						type: 'bar'
					}
				]
			};
			getchart.clear();
			getchart.setOption(option);
			//随着屏幕大小调节图表
			window.addEventListener('resize', () => {
				getchart.resize();
			});
		},
		loadData() {
			if(this.CrossTabs.chartType ==''){
				this.longBar();
			}else{
				
			this.selection(this.CrossTabs.chartType)
			}
		}
	}
};
</script>

<style scoped="scoped" lang="scss">
.manyChart {
	.title_box {
		width: 100%;
		height: 56px;
		line-height: 56px;
		background: #f9fcff;
		.title_box_span {
			margin-left: 25px;
			font-size: 14px;
			color: #000;
			font-family: Microsoft YaHei;
		}
		.el-dropdown_button {
			float: right;
			margin-right: 20px;
		}
	}
	.echart {
		width: 90%;
		height: 400px;
		margin: 20px auto;
	}
	table {
		width: 90%;
		margin: 0 auto;
		border: 1px solid #dbdada;
		margin-bottom: 20px;
		border-collapse: collapse;
		border-spacing: 0;
		margin-top: 20px;
	}
	
	table tr td {
		padding: 8px 0 8px 10px;
	}
}
</style>
